(function() {

  var ROOT_ID = 'ph-sticky-cart-root';
  var POST_ADD_REDIRECT = '/cart';
  var DESKTOP_BREAKPOINT = 768;

  var CURRENCY_SYMBOLS = { 'AUD': '$', 'USD': '$', 'CAD': '$', 'NZD': '$', 'GBP': '£', 'EUR': '€' };

  function getCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? window.Shopify.currency.active : 'USD';
  }

  function symbolFor(c) {
    return CURRENCY_SYMBOLS[c] || '$';
  }

  function formatMoney(amount, currency) {
    try {
      return symbolFor(currency) + new Intl.NumberFormat(undefined, {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(amount);
    } catch (e) { return '$' + amount.toFixed(2); }
  }

  var COLOR_NAVY        = '#1e2764';
  var COLOR_BLUE        = '#2a5bd7';
  var COLOR_BORDER_BLUE = '#4f46e5';
  var COLOR_GREEN       = '#01b778';
  var COLOR_GRAY_TEXT   = '#6b7280';
  var COLOR_GRAY_BORDER = '#d8dce3';
  var COLOR_FILL        = '#eef0fc';

  var mode = null; // 'bridge' | 'generic'
  var bridge = null;
  var generic = { product: null, currentVariantId: null, currency: getCurrency() };
  var mobileExpanded = false;
  var desktopExpanded = false;
  var els = {};

  // ── Bridge detection ─────────────────────────────────────────────────────
  // Only the main filter product actually runs the bridge-providing offer
  // script — every other product can skip the poll entirely and go straight
  // to generic mode instead of waiting up to 4.5s to find out it's not there.
  var BRIDGE_PRODUCT_HANDLE = 'purahome-stainless-steel-tap-water-filter';

  function pollForBridge(currentHandle, callback) {
    if (currentHandle !== BRIDGE_PRODUCT_HANDLE) {
      callback(null);
      return;
    }

    var attempts = 0;
    var maxAttempts = 30; // ~4.5s at 150ms
    function check() {
      if (window.PuraHomeOffer && window.PuraHomeOffer.isReady()) {
        callback(window.PuraHomeOffer);
        return;
      }
      attempts++;
      if (attempts >= maxAttempts) { callback(null); return; }
      setTimeout(check, 150);
    }
    check();
  }

  function injectResponsiveStyles() {
    if (document.getElementById('ph-sticky-responsive-styles')) return;
    var style = document.createElement('style');
    style.id = 'ph-sticky-responsive-styles';
    style.textContent =
      '#ph-sticky-mobile-row { display:flex; }' +
      '#ph-sticky-desktop-row { display:none; }' +
      '@media (min-width: ' + DESKTOP_BREAKPOINT + 'px) {' +
      '  #ph-sticky-mobile-row { display:none !important; }' +
      '  #ph-sticky-desktop-row { display:flex !important; }' +
      '}';
    document.head.appendChild(style);
  }

  // ── Shared bits ──────────────────────────────────────────────────────────
  function pctLabelHtml(label, pct) {
    var pctHtml = (pct !== null && pct !== undefined) ? ' <span style="color:' + COLOR_GREEN + ';">(' + pct + '% OFF)</span>' : '';
    return label + pctHtml;
  }

  function buildOptionRow(label, pct, priceText, isSelected, onClick) {
    var row = document.createElement('div');
    row.style.cssText =
      'display:flex;align-items:center;justify-content:space-between;cursor:pointer;gap:8px;' +
      'border:1.5px solid ' + (isSelected ? COLOR_BORDER_BLUE : COLOR_GRAY_BORDER) + ';' +
      'background:' + (isSelected ? COLOR_FILL : '#fff') + ';border-radius:8px;padding:8px 10px;';

    var left = document.createElement('div');
    left.style.cssText = 'min-width:0;';
    left.innerHTML =
      '<div style="font-size:12.5px;font-weight:700;color:' + COLOR_NAVY + ';white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + pctLabelHtml(label, pct) + '</div>' +
      '<div style="font-size:10.5px;color:' + COLOR_GRAY_TEXT + ';">' + priceText + '</div>';
    row.appendChild(left);

    if (isSelected) {
      var check = document.createElement('div');
      check.style.cssText = 'flex:0 0 auto;';
      check.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="' + COLOR_BORDER_BLUE + '" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="5 13 10 18 19 7"/></svg>';
      row.appendChild(check);
    }

    row.addEventListener('click', onClick);
    return row;
  }

  // ── Build: mobile row (compact pill, optional thumbnail in generic mode) ─
  function buildMobileRow(root) {
    var row = document.createElement('div');
    row.id = 'ph-sticky-mobile-row';
    row.style.cssText = 'flex-direction:column;';

    var collapsedRow = document.createElement('div');
    collapsedRow.style.cssText = 'padding:10px;display:flex;gap:8px;align-items:stretch;';

    if (mode === 'generic') {
      var imgWrap = document.createElement('div');
      imgWrap.style.cssText =
        'flex:0 0 auto;width:44px;height:44px;border-radius:8px;overflow:hidden;' +
        'background:#f4f5f9;display:flex;align-items:center;justify-content:center;';
      var img = document.createElement('img');
      img.id = 'ph-sticky-thumb';
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
      imgWrap.appendChild(img);
      collapsedRow.appendChild(imgWrap);
    }

    var pill = document.createElement('div');
    pill.style.cssText =
      'flex:1 1 auto;min-width:0;border:1.5px solid ' + COLOR_GRAY_BORDER + ';border-radius:10px;' +
      'padding:8px 12px;display:flex;align-items:center;justify-content:space-between;cursor:pointer;';

    var pillText = document.createElement('div');
    pillText.style.cssText = 'min-width:0;';
    var pillLabel = document.createElement('div');
    pillLabel.id = 'ph-sticky-pill-label';
    pillLabel.style.cssText = 'font-size:13.5px;font-weight:700;color:' + COLOR_NAVY + ';white-space:nowrap;overflow:hidden;text-overflow:ellipsis;';
    var pillPrice = document.createElement('div');
    pillPrice.id = 'ph-sticky-pill-price';
    pillPrice.style.cssText = 'font-size:11.5px;color:' + COLOR_GRAY_TEXT + ';margin-top:1px;';
    pillText.appendChild(pillLabel);
    pillText.appendChild(pillPrice);
    pill.appendChild(pillText);

    var chevron = document.createElement('div');
    chevron.style.cssText = 'flex:0 0 auto;display:flex;align-items:center;margin-left:8px;';
    chevron.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="' + COLOR_NAVY + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
    pill.appendChild(chevron);

    pill.addEventListener('click', toggleMobileExpanded);
    collapsedRow.appendChild(pill);

    var collapsedBuyBtn = document.createElement('button');
    collapsedBuyBtn.type = 'button';
    collapsedBuyBtn.textContent = 'Buy Now';
    collapsedBuyBtn.style.cssText =
      'flex:0 0 auto;background:' + COLOR_BLUE + ';color:#fff;font-weight:700;font-size:13.5px;text-align:center;' +
      'border:none;border-radius:10px;padding:0 18px;white-space:nowrap;cursor:pointer;';
    collapsedBuyBtn.addEventListener('click', function() { doAddToCart(collapsedBuyBtn); });
    collapsedRow.appendChild(collapsedBuyBtn);

    row.appendChild(collapsedRow);
    els.mobileCollapsedRow = collapsedRow;

    var expandedWrap = document.createElement('div');
    expandedWrap.id = 'ph-sticky-expanded';
    expandedWrap.style.cssText = 'display:none;';

    var optionsWrap = document.createElement('div');
    optionsWrap.id = 'ph-sticky-options';
    optionsWrap.style.cssText = 'padding:8px;max-height:260px;overflow-y:auto;display:flex;flex-direction:column;gap:6px;border-bottom:1px solid ' + COLOR_GRAY_BORDER + ';';
    expandedWrap.appendChild(optionsWrap);

    var expandedBtnWrap = document.createElement('div');
    expandedBtnWrap.style.cssText = 'padding:10px;';
    var expandedBuyBtn = document.createElement('button');
    expandedBuyBtn.type = 'button';
    expandedBuyBtn.id = 'ph-sticky-buy-expanded';
    expandedBuyBtn.style.cssText =
      'width:100%;background:' + COLOR_BLUE + ';color:#fff;font-weight:700;font-size:13.5px;text-align:center;' +
      'border:none;border-radius:10px;padding:11px;cursor:pointer;';
    expandedBuyBtn.addEventListener('click', function() { doAddToCart(expandedBuyBtn); });
    expandedBtnWrap.appendChild(expandedBuyBtn);
    expandedWrap.appendChild(expandedBtnWrap);

    row.appendChild(expandedWrap);
    root.appendChild(row);
  }

  function toggleMobileExpanded() {
    mobileExpanded = !mobileExpanded;
    var expandedWrap = document.getElementById('ph-sticky-expanded');
    els.mobileCollapsedRow.style.display = mobileExpanded ? 'none' : 'flex';
    expandedWrap.style.display = mobileExpanded ? 'block' : 'none';
  }

  // ── Build: desktop row (thumbnail + name left, selector + button right) ──
  function buildDesktopRow(root) {
    var row = document.createElement('div');
    row.id = 'ph-sticky-desktop-row';
    row.style.cssText = 'align-items:center;justify-content:space-between;padding:12px 28px;gap:20px;';

    var left = document.createElement('div');
    left.style.cssText = 'display:flex;align-items:center;gap:14px;min-width:0;flex:1 1 auto;';

    var thumbWrap = document.createElement('div');
    thumbWrap.style.cssText =
      'flex:0 0 auto;width:52px;height:52px;border-radius:8px;overflow:hidden;' +
      'background:#f4f5f9;display:flex;align-items:center;justify-content:center;';
    var thumb = document.createElement('img');
    thumb.id = 'ph-sticky-desktop-thumb';
    thumb.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block;';
    thumbWrap.appendChild(thumb);
    left.appendChild(thumbWrap);

    var nameEl = document.createElement('div');
    nameEl.id = 'ph-sticky-desktop-name';
    nameEl.style.cssText = 'font-size:15px;font-weight:700;color:' + COLOR_NAVY + ';white-space:nowrap;overflow:hidden;text-overflow:ellipsis;';
    left.appendChild(nameEl);

    row.appendChild(left);

    var right = document.createElement('div');
    right.style.cssText = 'display:flex;align-items:center;gap:10px;flex:0 0 auto;';

    var pillWrap = document.createElement('div');
    pillWrap.style.cssText = 'position:relative;';

    var pill = document.createElement('div');
    pill.style.cssText =
      'border:1.5px solid ' + COLOR_GRAY_BORDER + ';border-radius:10px;padding:8px 14px;' +
      'display:flex;align-items:center;gap:14px;cursor:pointer;min-width:230px;';

    var pillText = document.createElement('div');
    var pillLabel = document.createElement('div');
    pillLabel.id = 'ph-sticky-desktop-pill-label';
    pillLabel.style.cssText = 'font-size:13.5px;font-weight:700;color:' + COLOR_NAVY + ';white-space:nowrap;';
    var pillPrice = document.createElement('div');
    pillPrice.id = 'ph-sticky-desktop-pill-price';
    pillPrice.style.cssText = 'font-size:11.5px;color:' + COLOR_GRAY_TEXT + ';margin-top:1px;';
    pillText.appendChild(pillLabel);
    pillText.appendChild(pillPrice);
    pill.appendChild(pillText);

    var chevron = document.createElement('div');
    chevron.id = 'ph-sticky-desktop-chevron';
    chevron.style.cssText = 'flex:0 0 auto;margin-left:auto;display:flex;align-items:center;transition:transform 0.15s ease;';
    chevron.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="' + COLOR_NAVY + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
    pill.appendChild(chevron);

    pill.addEventListener('click', toggleDesktopExpanded);
    pillWrap.appendChild(pill);

    var optionsWrap = document.createElement('div');
    optionsWrap.id = 'ph-sticky-desktop-options';
    optionsWrap.style.cssText =
      'display:none;position:absolute;bottom:calc(100% + 8px);left:0;width:100%;min-width:260px;' +
      'background:#fff;border:1px solid ' + COLOR_GRAY_BORDER + ';border-radius:10px;' +
      'box-shadow:0 8px 24px rgba(17,24,39,0.12);padding:6px;max-height:300px;overflow-y:auto;z-index:1;';
    pillWrap.appendChild(optionsWrap);

    right.appendChild(pillWrap);

    var buyBtn = document.createElement('button');
    buyBtn.type = 'button';
    buyBtn.id = 'ph-sticky-desktop-buy';
    buyBtn.textContent = 'Buy Now';
    buyBtn.style.cssText =
      'flex:0 0 auto;background:' + COLOR_BLUE + ';color:#fff;font-weight:700;font-size:13.5px;text-align:center;' +
      'border:none;border-radius:10px;padding:11px 22px;white-space:nowrap;cursor:pointer;';
    buyBtn.addEventListener('click', function() { doAddToCart(buyBtn); });
    right.appendChild(buyBtn);

    row.appendChild(right);
    root.appendChild(row);

    // Close the desktop dropdown if the user clicks anywhere outside it
    document.addEventListener('click', function(e) {
      if (desktopExpanded && !pillWrap.contains(e.target)) {
        toggleDesktopExpanded();
      }
    });
  }

  function toggleDesktopExpanded() {
    desktopExpanded = !desktopExpanded;
    var optionsWrap = document.getElementById('ph-sticky-desktop-options');
    var chevron = document.getElementById('ph-sticky-desktop-chevron');
    if (optionsWrap) optionsWrap.style.display = desktopExpanded ? 'block' : 'none';
    if (chevron) chevron.style.transform = desktopExpanded ? 'rotate(180deg)' : 'rotate(0deg)';
  }

  // ── Shell ────────────────────────────────────────────────────────────────
  function buildBar(root) {
    root.innerHTML = '';
    injectResponsiveStyles();

    var bar = document.createElement('div');
    bar.id = 'ph-sticky-bar';
    bar.style.cssText =
      'background:#fff;box-shadow:0 -4px 14px rgba(17,24,39,0.08);' +
      'box-sizing:border-box;transform:translateY(100%);transition:transform 0.25s ease;';

    buildMobileRow(bar);
    buildDesktopRow(bar);

    root.appendChild(bar);
    els.bar = bar;
  }

  // ── Update: bridge mode (main filter product) ───────────────────────────
  function updateBarBridge() {
    var variant = bridge.getCurrentVariant();
    if (!variant) return;
    var meta = bridge.getVariantMeta(variant.title) || { label: variant.title, days: 365 };
    var currency = bridge.getCurrency();
    var pct = (variant.compare_price && variant.compare_price > variant.price)
      ? Math.round((1 - variant.price / variant.compare_price) * 100) : null;
    var perDayText = symbolFor(currency) + (variant.price / meta.days).toFixed(2) + '/day';

    // Mobile pill
    var pillLabel = document.getElementById('ph-sticky-pill-label');
    var pillPrice = document.getElementById('ph-sticky-pill-price');
    if (pillLabel) pillLabel.innerHTML = pctLabelHtml(meta.label, pct);
    if (pillPrice) pillPrice.textContent = perDayText;

    var expandedBuyBtn = document.getElementById('ph-sticky-buy-expanded');
    if (expandedBuyBtn) expandedBuyBtn.textContent = bridge.getCtaLabel(variant);

    var optionsWrap = document.getElementById('ph-sticky-options');
    if (optionsWrap) {
      optionsWrap.innerHTML = '';
      bridge.getVariants().forEach(function(v) {
        var vMeta = bridge.getVariantMeta(v.title) || { label: v.title, days: 365 };
        var vPct = (v.compare_price && v.compare_price > v.price) ? Math.round((1 - v.price / v.compare_price) * 100) : null;
        var row = buildOptionRow(vMeta.label, vPct, symbolFor(currency) + (v.price / vMeta.days).toFixed(2) + '/day', v.id === variant.id, function() {
          if (!v.available) return;
          bridge.selectVariant(v.id);
          toggleMobileExpanded();
        });
        if (!v.available) row.style.opacity = '0.5';
        optionsWrap.appendChild(row);
      });
    }

    // Desktop row
    var dThumb = document.getElementById('ph-sticky-desktop-thumb');
    if (dThumb && meta.image) dThumb.src = meta.image;
    var dName = document.getElementById('ph-sticky-desktop-name');
    if (dName) dName.textContent = document.title.split('|')[0].trim() || meta.label;
    var dPillLabel = document.getElementById('ph-sticky-desktop-pill-label');
    var dPillPrice = document.getElementById('ph-sticky-desktop-pill-price');
    if (dPillLabel) dPillLabel.innerHTML = pctLabelHtml(meta.label, pct);
    if (dPillPrice) dPillPrice.textContent = perDayText;
    var dBuyBtn = document.getElementById('ph-sticky-desktop-buy');
    if (dBuyBtn) dBuyBtn.textContent = bridge.getCtaLabel(variant);

    var dOptionsWrap = document.getElementById('ph-sticky-desktop-options');
    if (dOptionsWrap) {
      dOptionsWrap.innerHTML = '';
      bridge.getVariants().forEach(function(v) {
        var vMeta = bridge.getVariantMeta(v.title) || { label: v.title, days: 365 };
        var vPct = (v.compare_price && v.compare_price > v.price) ? Math.round((1 - v.price / v.compare_price) * 100) : null;
        var row = buildOptionRow(vMeta.label, vPct, symbolFor(currency) + (v.price / vMeta.days).toFixed(2) + '/day', v.id === variant.id, function() {
          if (!v.available) return;
          bridge.selectVariant(v.id);
          toggleDesktopExpanded();
        });
        if (!v.available) row.style.opacity = '0.5';
        dOptionsWrap.appendChild(row);
      });
    }
  }

  // ── Update: generic mode (any other product) ────────────────────────────
  function updateBarGeneric() {
    var product = generic.product;
    if (!product) return;
    var variant = product.variants.filter(function(v) { return v.id === generic.currentVariantId; })[0];
    if (!variant) return;
    var currency = generic.currency;

    var imgSrc = (variant.featured_image && variant.featured_image.src) || product.featured_image || (product.images && product.images[0]);
    var variantLabel = product.title + (variant.title !== 'Default Title' ? ' — ' + variant.title : '');
    var priceText = formatMoney(variant.price / 100, currency);

    var thumb = document.getElementById('ph-sticky-thumb');
    if (thumb && imgSrc) thumb.src = imgSrc;

    var pillLabel = document.getElementById('ph-sticky-pill-label');
    var pillPrice = document.getElementById('ph-sticky-pill-price');
    if (pillLabel) pillLabel.textContent = variantLabel;
    if (pillPrice) pillPrice.textContent = priceText;

    var expandedBuyBtn = document.getElementById('ph-sticky-buy-expanded');
    if (expandedBuyBtn) expandedBuyBtn.textContent = 'Buy Now';

    var optionsWrap = document.getElementById('ph-sticky-options');
    if (optionsWrap) {
      optionsWrap.innerHTML = '';
      product.variants.forEach(function(v) {
        var label = v.title !== 'Default Title' ? v.title : product.title;
        var row = buildOptionRow(label, null, formatMoney(v.price / 100, currency), v.id === generic.currentVariantId, function() {
          if (!v.available) return;
          generic.currentVariantId = v.id;
          updateBarGeneric();
          toggleMobileExpanded();
        });
        if (!v.available) row.style.opacity = '0.5';
        optionsWrap.appendChild(row);
      });
    }

    // Desktop row
    var dThumb = document.getElementById('ph-sticky-desktop-thumb');
    if (dThumb && imgSrc) dThumb.src = imgSrc;
    var dName = document.getElementById('ph-sticky-desktop-name');
    if (dName) dName.textContent = product.title;
    var dPillLabel = document.getElementById('ph-sticky-desktop-pill-label');
    var dPillPrice = document.getElementById('ph-sticky-desktop-pill-price');
    if (dPillLabel) dPillLabel.textContent = variant.title !== 'Default Title' ? variant.title : product.title;
    if (dPillPrice) dPillPrice.textContent = priceText;
    var dBuyBtn = document.getElementById('ph-sticky-desktop-buy');
    if (dBuyBtn) dBuyBtn.textContent = 'Buy Now';

    var dOptionsWrap = document.getElementById('ph-sticky-desktop-options');
    if (dOptionsWrap) {
      dOptionsWrap.innerHTML = '';
      product.variants.forEach(function(v) {
        var label = v.title !== 'Default Title' ? v.title : product.title;
        var row = buildOptionRow(label, null, formatMoney(v.price / 100, currency), v.id === generic.currentVariantId, function() {
          if (!v.available) return;
          generic.currentVariantId = v.id;
          updateBarGeneric();
          toggleDesktopExpanded();
        });
        if (!v.available) row.style.opacity = '0.5';
        dOptionsWrap.appendChild(row);
      });
    }
  }

  // ── Add to cart (shared) ─────────────────────────────────────────────────
  function doAddToCart(buttonEl) {
    var originalText = buttonEl.textContent;
    buttonEl.disabled = true;
    buttonEl.style.opacity = '0.7';
    buttonEl.textContent = 'Adding...';

    var promise = (mode === 'bridge') ? bridge.addToCart() : genericAddToCart();

    promise
      .then(function() {
        buttonEl.disabled = false;
        buttonEl.style.opacity = '';
        buttonEl.textContent = originalText;
      })
      .catch(function(err) {
        console.error('[PH-STICKY] Add to cart failed —', err);
        buttonEl.disabled = false;
        buttonEl.style.opacity = '';
        buttonEl.textContent = originalText;
        alert('Something went wrong adding this to your cart — please try again.');
      });
  }

  function genericAddToCart() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: generic.currentVariantId, quantity: 1 }] })
    })
      .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function(result) {
        try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
        return tryOpenDrawer().then(function(opened) {
          if (!opened) window.location.href = POST_ADD_REDIRECT;
          return result;
        });
      });
  }

  // ── Drawer awareness ─────────────────────────────────────────────────────
  // The cart drawer and this bar are both anchored to the screen edge, so
  // they can visually collide (our bar sitting on top of the drawer's own
  // checkout button). Simplest reliable fix: hide the bar entirely whenever
  // the drawer is open, regardless of how it was opened, and restore it
  // when the drawer closes.
  function setupDrawerAwareness() {
    var bar = els.bar;
    var drawer = document.querySelector('cart-drawer');
    if (!bar || !drawer) return;

    function isDrawerOpen() {
      if (drawer.hasAttribute('open')) return true;
      if (drawer.classList.contains('is-open') || drawer.classList.contains('active') || drawer.classList.contains('drawer--open')) return true;
      var style = window.getComputedStyle(drawer);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      var rect = drawer.getBoundingClientRect();
      return rect.width > 0 && rect.left < window.innerWidth && rect.right > 0;
    }

    function syncVisibility() {
      bar.style.display = isDrawerOpen() ? 'none' : '';
    }

    var observer = new MutationObserver(syncVisibility);
    observer.observe(drawer, { attributes: true, attributeFilter: ['class', 'open', 'style'] });

    syncVisibility();
  }

  function tryOpenDrawer() {
    try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
    return fetch('/?section_id=cart-drawer')
      .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var freshDrawer = doc.querySelector('cart-drawer');
        var existingDrawer = document.querySelector('cart-drawer');
        if (!freshDrawer || !existingDrawer) return false;
        existingDrawer.outerHTML = freshDrawer.outerHTML;
        var newDrawer = document.querySelector('cart-drawer');
        if (!newDrawer) return false;
        // outerHTML swap creates a brand new node — re-bind drawer
        // awareness so it's watching the live element, not a detached one.
        setupDrawerAwareness();
        if (typeof newDrawer.open === 'function') newDrawer.open();
        else if (typeof newDrawer.show === 'function') newDrawer.show();
        else { newDrawer.setAttribute('open', ''); newDrawer.classList.add('is-open', 'active', 'drawer--open'); }
        if (els.bar) els.bar.style.display = 'none';
        return true;
      })
      .catch(function() {
        var iconCandidates = [
          '#CartDrawer-Toggle', '.js-drawer-open-cart', '#cart-icon-bubble',
          '.site-header__cart', 'a.site-header__icon--cart', '.header__icon--cart', '[data-cart-icon]'
        ];
        for (var j = 0; j < iconCandidates.length; j++) {
          var icon = document.querySelector(iconCandidates[j]);
          if (icon) { icon.click(); return true; }
        }
        return false;
      });
  }

  // ── Visibility (scroll-triggered) ───────────────────────────────────────
  function setupVisibility() {
    var bar = els.bar;
    if (!bar || typeof IntersectionObserver === 'undefined') return;

    var target = document.getElementById('ph2-cta') || document.querySelector('form[action*="/cart/add"]');

    if (target) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            bar.style.transform = 'translateY(100%)';
          } else {
            var rect = target.getBoundingClientRect();
            bar.style.transform = (rect.top < 0) ? 'translateY(0)' : 'translateY(100%)';
          }
        });
      }, { threshold: 0 });
      observer.observe(target);
    } else {
      var ticking = false;
      window.addEventListener('scroll', function() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function() {
          bar.style.transform = (window.scrollY > window.innerHeight) ? 'translateY(0)' : 'translateY(100%)';
          ticking = false;
        });
      }, { passive: true });
    }
  }

  // ── Init ─────────────────────────────────────────────────────────────────
  function init() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;

    var currentHandle = root.getAttribute('data-product-handle');

    pollForBridge(currentHandle, function(found) {
      if (found) {
        mode = 'bridge';
        bridge = found;
        buildBar(root);
        bridge.onChange(updateBarBridge);
        updateBarBridge();
        setupVisibility();
        setupDrawerAwareness();
      } else {
        mode = 'generic';
        var handle = currentHandle;
        if (!handle) return;

        fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function(product) {
            generic.product = product;
            var firstAvailable = product.variants.filter(function(v) { return v.available; })[0] || product.variants[0];
            generic.currentVariantId = firstAvailable ? firstAvailable.id : null;
            buildBar(root);
            updateBarGeneric();
            setupVisibility();
            setupDrawerAwareness();
          })
          .catch(function(err) {
            console.error('[PH-STICKY] Failed to load product —', err);
          });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();